<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-list-alt" titulo="CADASTRO DE HISTÓRICO">
        <template #subtitulo>
            <div class="d-flex align-items-center flex-wrap">
                <span class="mr-2">
                    <i class="fa fa-key mr-1 text-info"></i>
                    CÓDIGO: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
                </span>
                <span v-if="registro.DESCRICAO" class="mx-2">•</span>
                <span v-if="registro.DESCRICAO" class="mr-2">
                    <i class="fa fa-file-text-o mr-1 text-info"></i>
                    {{registro.DESCRICAO}}
                </span>
            </div>
        </template>
        <template #acoes>
            <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop="postOrEdit">
                <i class="fa fa-save mr-1"></i> GRAVAR
            </b-button>
            <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop="voltar">
                <i class="fa fa-arrow-left mr-1"></i> Voltar
            </b-button>
        </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <b-row>
        <b-col md="9">
          <b-card no-body class="border-0 shadow-sm mb-4">
             <div class="card-header bg-white border-bottom-0 pt-3 pb-2">
               <div class="d-flex align-items-center">
                   <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                       <i class="fa fa-info"></i>
                   </div>
                   <div>
                       <h6 class="mb-0 font-weight-bold">Identificação</h6>
                       <small class="text-muted">Dados principais do histórico</small>
                   </div>
               </div>
            </div>
            <b-card-body class="p-4">
               <b-row class="mb-3">
                  <b-col md="2">
                    <label class="modal-label-premium">ID</label>
                    <b-form-input disabled v-model="registro.CODIGO" class="rounded-pill shadow-xs bg-light" />
                  </b-col>

                  <b-col md="6">
                    <label class="modal-label-premium">Descrição</label>
                    <b-form-input id="edDESCRICAO" ref="edDESCRICAO" v-model="registro.DESCRICAO" :state="!!registro.DESCRICAO" placeholder="Informe a descrição" class="rounded-pill shadow-xs" />
                  </b-col>

                  <b-col md="2">
                    <label class="modal-label-premium">Status</label>
                    <b-form-select v-model="registro.STATUS" :options="[{value:'1',text:'Ativo'},{value:'0',text:'Inativo'}]" class="rounded-pill shadow-xs" />
                  </b-col>

                  <b-col md="2">
                    <label class="modal-label-premium">Afeta Saldo?</label>
                    <b-form-select v-model="registro.AFETA_SALDO" :options="[{value:'S',text:'Sim'},{value:'N',text:'Não'}]" class="rounded-pill shadow-xs" />
                  </b-col>
               </b-row>
               
               <h6 class="text-primary font-weight-bold border-bottom pb-2 mb-3 mt-4"><i class="fa fa-sitemap mr-2"></i>Estrutura Hierárquica</h6>
               <b-row class="mb-3">
                  <b-col md="4">
                    <label class="modal-label-premium">Predecessor (Hierarquia)</label>
                    <b-input-group class="rounded-pill shadow-xs">
                        <b-form-input :value="labelPredecessor" disabled class="rounded-left-pill border-right-0" />
                        <b-input-group-append>
                           <b-button variant="primary" @click="abrirModalPredecessor" class="rounded-right-pill">
                               <i class="fa fa-search"></i>
                           </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <small class="text-muted pl-2">Selecione pelo botão.</small>
                  </b-col>

                  <b-col md="2">
                    <label class="modal-label-premium">Dígito (próx.)</label>
                    <b-form-input :value="proximoDigito" disabled class="rounded-pill shadow-xs bg-light text-center" />
                  </b-col>

                  <b-col md="2">
                    <label class="modal-label-premium">Código Completo</label>
                    <b-form-input :value="codigoCompletoPreview" disabled class="rounded-pill shadow-xs bg-light font-weight-bold" />
                  </b-col>

                  <b-col md="2">
                    <label class="modal-label-premium">Grau (nível)</label>
                    <b-form-input :value="grauPreview" disabled class="rounded-pill shadow-xs bg-light text-center" />
                  </b-col>
                  
                  <b-col md="2">
                    <label class="modal-label-premium">Tipo</label>
                    <b-input-group class="rounded-pill shadow-xs">
                        <b-input-group-prepend>
                            <b-input-group-text class="rounded-left-pill bg-white border-right-0">
                                <strong :class="['fa fa-circle', colorirTIPO(registro.TIPO)]" ></strong>
                            </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input id="edtipo" ref="edtipo" disabled v-model="registro.TIPO" class="rounded-right-pill border-left-0 bg-white" />
                    </b-input-group>
                  </b-col>
               </b-row>

               <b-row>
                  <b-col md="12">
                     <label class="modal-label-premium">Observação</label>
                     <b-form-textarea v-model="registro.OBS" rows="4" class="shadow-xs" style="border-radius: 15px;" />
                  </b-col>
               </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col md="3">
          <b-card no-body class="border-0 shadow-sm mb-4">
            <div class="card-header bg-white border-bottom-0 pt-3 pb-2">
               <div class="d-flex align-items-center">
                   <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                       <i class="fa fa-calendar-check-o"></i>
                   </div>
                   <div>
                       <h6 class="mb-0 font-weight-bold">Auditoria</h6>
                       <small class="text-muted">Registro de alterações</small>
                   </div>
               </div>
            </div>
            <b-card-body class="p-4">
                <b-form-group>
                  <label class="modal-label-premium">Usuário Cadastro</label>
                  <b-form-input v-model="registro.USUARIO_CADASTRO" disabled class="rounded-pill shadow-xs bg-light small" />
                </b-form-group>
                <b-form-group>
                  <label class="modal-label-premium">Data Cadastro</label>
                  <b-form-input v-model="dtCadastro" disabled class="rounded-pill shadow-xs bg-light small" />
                </b-form-group>
                <b-form-group>
                  <label class="modal-label-premium">Usuário Alteração</label>
                  <b-form-input v-model="registro.USUARIO_ALTERACAO" disabled class="rounded-pill shadow-xs bg-light small" />
                </b-form-group>
                <b-form-group>
                  <label class="modal-label-premium">Data Alteração</label>
                  <b-form-input v-model="dtAlteracao" disabled class="rounded-pill shadow-xs bg-light small" />
                </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal id="modal-predecessor" ref="modalPredecessor" hide-footer centered size="lg" content-class="border-0 shadow-lg">
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center w-100">
             <div class="header-icon-wrapper-modal bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <i class="fa fa-search"></i>
            </div>
            <h5 class="mb-0 font-weight-bold">Selecionar Predecessor</h5>
            <b-button variant="link" class="ml-auto text-dark" @click="close">
                <i class="fa fa-times"></i>
            </b-button>
        </div>
      </template>

      <div class="p-3">
        <b-form-group label="Filtro por descrição" label-class="font-weight-bold">
            <b-form-input v-model="filtroPred" placeholder="Digite para filtrar..." class="rounded-pill shadow-sm" autofocus />
        </b-form-group>

        <b-table ref="tblPred" small hover striped :items="predecessoresFiltrados"
                :fields="[
                  { key: 'CODIGO_COMPLETO', label: 'Cód.' },
                  { key: 'DESCRICAO', label: 'Descrição' },
                  { key: 'TIPO', label: 'Tipo' }
                ]"
                class="table-finance shadow-sm border rounded"
                :tbody-tr-class="predTrClass"
                @row-dblclicked="selecionarPredecessor">
          <template #cell(TIPO)="ctx">
            <b-badge :variant="ctx.item.TIPO==='CREDITO' ? 'success' : (ctx.item.TIPO==='DEBITO' ? 'danger' : 'secondary')">
              {{ctx.item.TIPO}}
            </b-badge>
          </template>
        </b-table>
      </div>

      <div class="p-3 bg-light border-top text-right rounded-bottom">
        <b-button variant="outline-secondary" class="rounded-pill font-weight-bold" @click="$refs.modalPredecessor.hide()">Fechar</b-button>
      </div>
    </b-modal>

    <b-alert
      v-if="duplicado == true"
      show variant="danger" class="py-1 px-2 mt-2 shadow-sm rounded">
      <i class="fa fa-exclamation-circle mr-1"></i> Já existe um histórico com o código <strong>{{ codigoCompletoPreview }}</strong>. Ajuste o predecessor/dígito.
    </b-alert>
    <b-alert v-if="mismatchDigitWarn" show variant="warning" class="py-1 px-2 mt-2 shadow-sm rounded">
      <i class="fa fa-warning mr-1"></i> {{ mismatchDigitWarn }}
    </b-alert>

  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import moment from 'moment'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  components: {
    HeaderPadrao
  },
  data() {
    return {
      emAlteracao: false,
      // lista cache de predecessores (ativos)
      predecessores: [],
      predecessorSel: null,  // objeto RCPLANO0 selecionado
      filtroPred: '',

      PREDECESSOR_CODIGO_COMPLETO: null, // só para edição antiga, agora ficará em predecessorSel
      dtAlteracao: '',
      dtCadastro: '',

      registro: {
        // ... (igual antes)
        TIPO: 'DEBITO',
        STATUS: '1',
        HISTORICO_PREDECESSOR_ID: null,
        CODIGO_PLANO: null,
        CODIGO_UNICO: null,
        CODIGO_COMPLETO: null,
        CODIGO_DIGITO: null,
        GRAU: null,
        AFETA_SALDO: 'S',
        DESCRICAO: null,
        USUARIO_CADASTRO: null,
        DT_CADASTRO: null,
        USUARIO_ALTERACAO: null,
        DT_ALTERACAO: null,

        // ...
      },
      duplicado: false,
      // para checagem concorrente do dígito
      mismatchDigitWarn: null, // string|null
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },

    labelPredecessor() {
      if (!this.predecessorSel) return ''
      const c = this.predecessorSel.CODIGO_COMPLETO || this.predecessorSel.CODIGO_PLANO || ''
      const d = this.predecessorSel.DESCRICAO || ''
      return `${c} - ${d}`
    },

    // monta preview: <codigo do pai> + '.' + <proximoDigito>
    codigoCompletoPreview() {
      const pai = (this.predecessorSel?.CODIGO_COMPLETO || this.predecessorSel?.CODIGO_PLANO || '').toString().trim()
      const dig = this.proximoDigito != null ? String(this.proximoDigito) : (this.registro.CODIGO_UNICO || '')
      if (pai && dig) return `${pai}.${dig}`
      return pai || dig || (this.registro.CODIGO_COMPLETO || '')
    },

    grauPreview() {
      const c = (this.codigoCompletoPreview || '').split('.').filter(Boolean)
      return Math.max(1, c.length)
    },

    // calcula o próximo dígito disponível olhando os filhos do predecessor
    proximoDigito() {
      if (!this.predecessorSel) return null
      const paiId = this.predecessorSel.CODIGO
      const filhos = (this.predecessoresTodos || []).filter(x => x.HISTORICO_PREDECESSOR_ID === paiId)

      // tenta extrair do último segmento do CODIGO_COMPLETO; fallback para CODIGO_DIGITO/CODIGO_UNICO numérico
      let max = 0
      filhos.forEach(f => {
        let val = 0
        const comp = (f.CODIGO_COMPLETO || '').split('.').filter(Boolean)
        const last = comp[comp.length - 1]
        if (last && !isNaN(Number(last))) val = Number(last)
        else if (!isNaN(Number(f.CODIGO_DIGITO))) val = Number(f.CODIGO_DIGITO)
        else if (!isNaN(Number(f.CODIGO_UNICO))) val = Number(f.CODIGO_UNICO)
        if (val > max) max = val
      })
      return max + 1
    },

    // lista completa (ativos) para cálculos
    predecessoresTodos() {
      return this.predecessores || []
    },

    predecessoresFiltrados() {
      const q = (this.filtroPred || '').toLowerCase()
      if (!q) return this.predecessoresTodos
      return this.predecessoresTodos.filter(p =>
        (p.DESCRICAO || '').toLowerCase().includes(q) ||
        (p.CODIGO_COMPLETO || '').toLowerCase().includes(q) ||
        (String(p.CODIGO_PLANO || '')).toLowerCase().includes(q)
      )
    }
  },
  watch: {
    codigoCompletoPreview: {
      immediate: false,
      async handler() {
        // valida adiantado para já dar feedback de duplicidade
        await this.validarCodigoCompleto()
      }
    },
    // quando trocar o predecessor, já preenche campos derivados
    predecessorSel: {
      immediate: true,
      async handler(novo) {
        if (!novo) return
        // ... (o que você já tinha: setar IDs, raiz, etc.)
        // depois de ajustar campos locais, sincronize com servidor:
        await this.sincronizarProximoDigitoServidor()
        // atualize previews
        this.registro.CODIGO_COMPLETO = this.codigoCompletoPreview
        this.registro.GRAU = this.grauPreview
        this.registro.TIPO  = this.predecessorSel.TIPO
        // e rode a checagem de duplicidade
        await this.validarCodigoCompleto()
      }
    },
    
    
  },
  methods: {
    colorirTIPO(value) {
      const valor = value?.trim()
      switch (valor) {
        case 'DEBITO': return 'text-danger'
        case 'CREDITO': return 'text-success'  
        case 'COMPENSACAO': return 'text-waraning'
        default: 'text-secondary'
          break;
      }
    },
    _kbd(e) {
      // Ctrl/Cmd + Enter => Gravar
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault()
        this.postOrEdit()
      }
      // Esc => Voltar (fecha modal se aberto)
      if (e.key === 'Escape') {
        if (this.$refs.modalPredecessor && this.$refs.modalPredecessor.visible) {
          this.$refs.modalPredecessor.hide()
        } else {
          this.voltar()
        }
      }
    },
    async validarCodigoCompleto() {
      const cod = (this.codigoCompletoPreview || '').trim()
      if (!cod) { this.duplicado = false; return }
      try {
        const { data } = await this.$http.get('/api/protected/historico/existsCodigoCompleto', { params: { codigo: cod } })
        // se estiver editando, ignorar "duplicado" quando o id encontrado for o próprio
        const meuId = this.registro?.CODIGO
        this.duplicado = !!(data?.exists && data?.id !== meuId)
      } catch(e) {
        // em falha, não travar — apenas logar
        console.warn('Falha validação duplicidade:', e)
        this.duplicado = false
      }
    },
    predTrClass(row) {
      if (!row) return ''
      return (this.predecessorSel && row.CODIGO === this.predecessorSel.CODIGO)
        ? 'cec-row-selected' : ''
    },
    onModalPredShown() {
      this.$nextTick(() => {
        try {
          const el = this.$refs.tblPred?.$el?.querySelector('tbody tr.cec-row-selected')
          if (el && el.scrollIntoView) el.scrollIntoView({ block: 'center' })
        } catch {}
      })
    },
    async sincronizarProximoDigitoServidor() {
      if (!this.predecessorSel?.CODIGO) { this.mismatchDigitWarn = null; return }
      try {
        const pid = Number(this.predecessorSel.CODIGO)
        const { data } = await this.$http.get(`/api/protected/historico/proximo-digito/${pid}`)
        const nextSrv = Number(data?.next || 0) || null
        const nextLocal = Number(this.proximoDigito || 0) || null
        if (nextSrv && nextSrv !== nextLocal) {
          this.mismatchDigitWarn = `O dígito ${nextLocal} foi reservado por outro usuário. Sugerido pelo servidor: ${nextSrv}.`
          // Atualiza campos pro valor oficial
          this.registro.CODIGO_UNICO = String(nextSrv)
          this.registro.CODIGO_DIGITO = nextSrv
        } else {
          this.mismatchDigitWarn = null
        }
      } catch (e) {
        // em falha silencie — é apenas um hint
        this.mismatchDigitWarn = null
      }
    },
    voltar() { this.$router.push('/cadastros/historico/index') },

    abrirModalPredecessor() {
      this.$refs.modalPredecessor.show()
    },

    selecionarPredecessor(row) {
      this.predecessorSel = row
      this.$refs.modalPredecessor.hide()
    },

    async carregarPredecessores() {
      // Se a lista já está no store (veio da listagem), aproveita:
      let base = this.$store.getters['historico/LISTA']
      if (!Array.isArray(base) || !base.length) {
        // carrega do backend somente ativos
        await this.$store.commit('historico/SET_STATUS', '1')
        await this.$store.dispatch('historico/GET_LISTA')
        base = this.$store.getters['historico/LISTA'] || []
        // limpa filtro de status do store (opcional)
        this.$store.commit('historico/SET_STATUS', null)
      }
      // Predecessor pode ser qualquer histórico (inclusive topos 1/2/3/4)
      // Ordena por CODIGO_COMPLETO para facilitar a escolha
      this.predecessores = [...base].sort((a,b) => (a.CODIGO_COMPLETO || '').localeCompare(b.CODIGO_COMPLETO || ''))
    },

    // define o predecessor padrão: selecionado na listagem ou primeiro da lista
    definirPredecessorPadrao() {
      const idSel = this.$store.getters['historico/REGISTRO_SELECIONADO_ID']
      let found = null
      if (idSel) found = this.predecessores.find(p => p.CODIGO === idSel)
      this.predecessorSel = found || this.predecessores[0] || null
    },

    async postOrEdit () {
      // valida descrição
      if (!this.registro.DESCRICAO) {
        this.$refs.edDESCRICAO?.$refs?.input?.focus?.()
        return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Descrição')
      }
      // garante campos derivados antes de enviar
      if (this.predecessorSel) {
        this.registro.HISTORICO_PREDECESSOR_ID = this.predecessorSel.CODIGO
        const raiz = (this.predecessorSel.CODIGO_COMPLETO || this.predecessorSel.CODIGO_PLANO || '').toString().split('.')[0] || null
        this.registro.CODIGO_PLANO = raiz
      }
      this.registro.CODIGO_UNICO  = this.proximoDigito != null ? String(this.proximoDigito) : this.registro.CODIGO_UNICO
      this.registro.CODIGO_DIGITO = this.proximoDigito != null ? Number(this.proximoDigito) : this.registro.CODIGO_DIGITO
      this.registro.CODIGO_COMPLETO = this.codigoCompletoPreview
      this.registro.GRAU = this.grauPreview

      await this.validarCodigoCompleto()
      if (this.duplicado) {
        this.$bvToast.toast('Código já existente. Ajuste o predecessor/dígito antes de gravar.', { variant: 'danger', solid: true })
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        if (!this.registro.CODIGO) {
          const { data } = await this.$store.dispatch('historico/POST_REGISTRO', this.registro)
          const salvo = (data && (data.registro?.[0] || data.registro)) || null
          if (!salvo) { return Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível cadastrar') }
          this.registro = { ...salvo }

          this.$store.commit('historico/SET_LIMPAR')
          this.$store.commit('historico/SET_REGISTRO_SELECIONADO_ID', this.registro.CODIGO)
          this.$store.commit('historico/SET_PAGINA_ATUAL', 1)
          this.$store.commit('controle/setAguardando', false)
          this.$router.push('/cadastros/historico/index')
        } else {
          const { data } = await this.$store.dispatch('historico/EDIT_REGISTRO', { registro: this.registro, operacao: this.emAlteracao ? 'alt' : 'inc' })
          this.registro = (data?.registro) ?? this.registro
          this.$store.commit('controle/setAguardando', false)
          this.$router.push('/cadastros/historico/index')
        }
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível gravar as informações')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    }
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null
    await this.carregarPredecessores()

    if (id) {
      this.emAlteracao = true
      const result = await this.$store.dispatch('historico/GET_BY_ID', id)
      if (!result) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
        this.$router.replace('/cadastros/historico/index')
        return
      }
      this.registro = { ...result }
      this.dtCadastro = this.registro.DT_CADASTRO ? moment(String(this.registro.DT_CADASTRO)).format('DD/MM/YYYY') : ''
      this.dtAlteracao = this.registro.DT_ALTERACAO ? moment(String(this.registro.DT_ALTERACAO)).format('DD/MM/YYYY') : ''
      // define o predecessorSel a partir do registro existente
      const pai = this.predecessores.find(p => p.CODIGO === result.HISTORICO_PREDECESSOR_ID)
      this.predecessorSel = pai || null
    } else {
      this.emAlteracao = false
      this.definirPredecessorPadrao()            // ➊ pega da listagem ou 1º disponível
      // com predecessorSel definido, os watchers já preenchem dígito/código/grau
      this.$nextTick(() => this.$refs.edDESCRICAO?.focus?.())
    }

    this.$store.commit('controle/setAguardando', false)
  },
  mounted() {
    window.addEventListener('keydown', this._kbd)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._kbd)
  },
}

</script>



// WEBPACK FOOTER //
// src/views/cadastros/historico/HistoricoCadastro.vue